import React, { Component } from 'react'

class Input extends Component {
	render() {
		return (
			<div className='inp-container' style={this.props.containerStyle}>
				<label>
					<span className={`inp-placeholder ${this.props.value ? 'active' : ''}`}>
						{this.props.placeholder}
					</span>
					<input
						name={this.props.name}
						onChange={this.props.onChange}
						onKeyDown={this.props.onKeyDown}
						className={`inp ${this.props.className}`}
						type={this.props.type}
						value={this.props.value}
						style={{
							padding: this.props.placeholder ? '' : '20px 15px',
							...this.props.style,
						}}
						ref={this.props.inputRef}
						onFocus={this.props.onFocus}
						onBlur={this.props.onBlur}
						disabled={this.props.disabled}
						multiple={this.props.multiple}
						autoFocus={this.props.autoFocus}
					/>
				</label>
				{this.props.children}
			</div>
		)
	}
}

export default Input
